export default function debounce (fn, delay) {
  let fnTimeoutID = null

  return function () {
    clearTimeout(fnTimeoutID)

    const args = arguments
    const that = this

    fnTimeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
